import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {DocumentsService} from '../../../services/documents.service';
import {ApiClientService} from '../../../services/api-client.service';
import {UserService} from '../../admin/user/services/user.service';
import {AccountPermissionsService} from '../../../services/account-permissions.service';

@Component({
    selector: 'upload-file-modal',
    templateUrl: './upload-file-modal.component.html',
    styleUrls: ['./upload-file-modal.component.scss']
})
export class UploadFileModalComponent implements OnInit, OnDestroy {
    visibleSteps = ['file-details'];
    currentStep = 'file-details';
    currentUser: any;
    isPropertyManager: boolean;


    files: any[] = [];
    showLoader: boolean = false;

    constructor(public documentsService: DocumentsService,
                private api: ApiClientService,
                private userService: UserService,
                public readonly accountPermissionsService: AccountPermissionsService
    ) {
        this.currentUser = this.userService.account.user;
        this.isPropertyManager = this.currentUser.userType === 'property_manager';
    }

    onNextStepRequest(data) {
        if (this.currentStep === 'file-details') {
            if (this.visibleSteps.length === 1) {
                this.save(data);
            } else {
                this.files = data;
                this.currentStep = 'notification-details';
            }
        } else {
            this.save(data);
        }
    }

    save(files) {
        this.showLoader = true;
        this.documentsService.uploadMultipleFiles(files).subscribe(message => {
            this.showLoader = false;
            this.documentsService.goTo();
            this.documentsService.hideUploadFileModal();
        }, error => {
            this.showLoader = false;
            this.api.errorHandler(error, 'Failed to upload some of the files');
        });
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
    }

    calculateCurrentProgressBarLength() {
        if (this.currentStep === 'notification-details') {
            return '100%';
        }
        return '50%';
    }

    notifyUsersChange(notify: boolean) {
        if (notify) {
            if (this.isPropertyManager || this.accountPermissionsService.isUserCompanyAdmin() || this.accountPermissionsService.isUserAdmin()) {
                this.visibleSteps.push('notification-details');
            }
        } else {
            this.visibleSteps = this.visibleSteps.filter(stepName => stepName !== 'notification-details');
        }
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler() {
        setTimeout(() => this.documentsService.hideUploadFileModal(), 100);
    }

    changeStep(stepName: string) {
        if (stepName === 'file-details') {
            this.currentStep = stepName;
        }
    }
}




// WEBPACK FOOTER //
// /app/src/app/views/documents/upload-file-modal/upload-file-modal.component.ts